import {
  Loader,
  SPACING,
  Typography,
  FlexBox,
  JoonUIColor,
} from "@joonapp/web-shared"

const ClientListLoader = () => {
  return (
    <FlexBox
      justify="center"
      align="center"
      gap={SPACING.space2}
      wrap={false}
      style={{ height: "300px", width: "100%" }}
    >
      <FlexBox
        direction="row"
        align="center"
        gap={SPACING.space2}
        style={{
          width: "fit-content",
          padding: `${SPACING.space3} ${SPACING.space4}`,
          borderRadius: SPACING.space2,
          backgroundColor: JoonUIColor.background.xlightGray,
          border: `1px solid ${JoonUIColor.border.default}`,
        }}
      >
        <Loader size={16} color={JoonUIColor.icon.neutral} thickness={2} />
        <Typography
          variant="bodySmall"
          style={{ color: JoonUIColor.text.secondary }}
        >
          Loading clients...
        </Typography>
      </FlexBox>
    </FlexBox>
  )
}

export default ClientListLoader
